/**
 * The two ways to get Zibby running on your own machine, as the public pages
 * show them: the self-host install command, and the Zibby Studio downloads.
 * One place, so the hero, the self-hosted section and the download page never
 * show different commands or files.
 */

export const SELFHOST_INSTALL_COMMAND = 'curl -fsSL https://dl.zibby.app/selfhosted/latest/install.sh | bash';

export const STUDIO_DOWNLOAD_BASE_URL = 'https://dl.zibby.app';

// The files the release script writes under download/latest/ (the download
// page swaps in the manifest's versioned file once it has loaded).
export const STUDIO_LATEST_DOWNLOADS = {
  macArm:   `${STUDIO_DOWNLOAD_BASE_URL}/download/latest/Zibby%20Studio-mac-arm64.dmg`,
  macIntel: `${STUDIO_DOWNLOAD_BASE_URL}/download/latest/Zibby%20Studio-mac-x64.dmg`,
  winX64:   `${STUDIO_DOWNLOAD_BASE_URL}/download/latest/Zibby%20Studio-win-x64.exe`,
  winArm:   `${STUDIO_DOWNLOAD_BASE_URL}/download/latest/Zibby%20Studio-win-arm64.exe`,
};

/** The files the hero links: the fixed "latest" Apple Silicon dmg and the x64 Windows installer. */
export const STUDIO_HERO_DOWNLOADS = { mac: STUDIO_LATEST_DOWNLOADS.macArm, windows: STUDIO_LATEST_DOWNLOADS.winX64 };
